import script from "./HrCompanyName.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCompanyName.vue?vue&type=script&setup=true&lang=js"

import "./HrCompanyName.vue?vue&type=style&index=0&id=33e16966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e16966"]])

export default __exports__